export default "__VITE_ASSET__B4CyY2B2__"